import { create } from 'zustand';
/** Mirrors economyStore's exact pattern (packages/economy). */
export const progressionStore = create()(() => ({
    xp: 0,
    level: 1,
    lastLevelUp: null,
}));
